import React from 'react';

import { Box } from '@mui/material';

import styled from '@emotion/styled';

import Icons from '../../../../themes/icons';

type Props = {
  title?: string;
  requirementComponent?: React.ReactNode;
  active?: boolean;
};

export const InviteState: React.FC<Props> = ({ title, requirementComponent, active = false }) => {
  return (
    <Container>
      <TopSection>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: active ? '1px solid #37BB90' : '1px solid #9ca3af',
            height: '16px',
            width: '16px',
            borderRadius: '50%',
            backgroundColor: active ? '#37BB90' : 'transparent',
            color: '#fff',
          }}
        >
          {active && <Icons.TickWhiteIcon style={{ width: '10px', height: '10px' }} />}
        </Box>
        <Title>{title}</Title>
      </TopSection>
      {requirementComponent && (
        <BottomSection>
          <UncheckedLine active={active} />
          {requirementComponent}
        </BottomSection>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TopSection = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
`;

const BottomSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 18px;
  padding-left: 6px;
`;

const CheckedCircle = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid ${(props) => (props.active ? '#37BB90' : '#9ca3af')};
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? '#37BB90' : 'transparent')};
  color: #fff';
`;

const UncheckedLine = styled.span<{ active?: boolean }>`
  display: inline-block;
  border: 1px solid ${(props) => (props.active ? '#37BB90' : '#e5e7eb')};
  width: 1px;
  height: 70px;
`;

const Title = styled.h5`
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  padding: 0;
`;
